import { z } from "zod";
import { UIElementType } from "../../../AppConstants";
import { t } from "i18next";

const getPricingSettingsSchema = () => {
  return z.object({
    SettingsKey: z
      .string()
      .min(1, { message: "Settings key is required" })
      .describe(JSON.stringify({ elementType: UIElementType.TEXTFIELD, inputLabel: t("pricingSettingsList.settingsKey"), isRequired: true, isDisabled: true })),
    SettingsValue: z.union([z.literal(0), z.number().positive()])
      .nullable()
      .refine(value => value === null || value >= 0, {
        message: "If entered, the number must be positive or zero",
      }).describe(JSON.stringify({ inputType: "number", elementType: UIElementType.TEXTFIELD, inputLabel: t("pricingSettingsList.settingsValue"), isRequired: true })),
    Unit: z
      .string()
      .min(1, { message: "Unit is required" })
      .describe(JSON.stringify({ elementType: UIElementType.TEXTFIELD, inputLabel: t("pricingSettingsList.unit"), isRequired: true, isDisabled: true })),
    Description: z
      .string()
      .min(1, { message: "Description is required" })
      .describe(JSON.stringify({ elementType: UIElementType.TEXTFIELD, inputLabel: t("pricingSettingsList.description"), isRequired: true, isDisabled: true })),
  });
};

const getPricingSettingsDefaultValue = (value = null) => {
  return {
    SettingsKey: value ? value?.SettingsKey : "",
    SettingsValue: value ? value?.SettingsValue : 0,
    Unit: value ? value?.Unit : "",
    Description: value ? value?.Description : "",
  };
};

const getPricingSettingsAPIPostSchema = (countryCode, businessCode) => {
  return {
    countryCode: countryCode,
    businessCode: businessCode,
    pricingSettings: [
      {
        SettingsId: "",
        Description: null,
        Unit: null,
        SettingsKey: null,
        SettingsValue: null,
        Deleted: false,
        CountryCode: countryCode,
        BusinessCode: businessCode,
      },
    ],
  };
};

const getPricingSettingsAuditInfoSchema = () => {
  return {
    auditInfo: [
      {
        Location: "Pricing Settings",
        LocationKey: "",
        Action: null,
        shortDesc: null,
        currentState: null,
        previousState: null,
      },
    ],
  };
};

export { getPricingSettingsSchema, getPricingSettingsDefaultValue, getPricingSettingsAPIPostSchema, getPricingSettingsAuditInfoSchema };
